export default "__VITE_ASSET__8d0efae7__"